export default __webpack_public_path__ + "static/media/boogie-min.37a97e77.png";